/**************************************
 ** AtlasLoadingSequence
 *
 *
 ***************************************/
define('atlas/AtlasLoadingSequence', ['atlas/AtlasConstants'], function(Constants) {
    'use strict';

    var AtlasLoadingSequence = function() {
        this._16x16Sequence = [{
                name: '3x4',
                latitudes: ['G', 'I', 'K'],
                longitudes: ['03', '07', '11', '15'],
                pause: 0
            }, {
                name: '3x8',
                latitudes: ['G', 'I', 'K'],
                longitudes: ['01', '03', '05', '07', '09', '11', '13', '15'],
                pause: 0
            }, {
                name: '3x12 (jitter)',
                latitudes: ['G', 'I', 'K'],
                longitudes: ['01', '02', '03', '05', '06', '07', '09', '10', '11', '13', '14', '15'],
                pause: 0
            }, {
                name: '3x16',
                latitudes: ['G', 'I', 'K'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '5x16',
                latitudes: ['E', 'G', 'I', 'K', 'M'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '7x16',
                latitudes: ['C', 'E', 'G', 'I', 'K', 'M', 'O'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '9x16',
                latitudes: ['C', 'E', 'G', 'H', 'I', 'J', 'K', 'M', 'O'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '11x16',
                latitudes: ['C', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'O'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '13x16',
                latitudes: ['C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }, {
                name: '14x16',
                latitudes: ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
                longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                pause: 0
            }
        ];

        this._16x16PrioritySequence = {
            latitudes: ['G', 'I', 'K', 'E', 'M', 'C', 'H', 'J', 'O', 'F', 'L', 'B', 'N', 'D'],
            longitudes: ['03', '07', '11', '15', '01', '05', '02', '09', '13', '04', '14', '06', '16', '08', '10', '12'],
            limits: [{
                    latitudes: 3,
                    longitudes: 4
                }, {
                    latitudes: 3,
                    longitudes: 8
                }, {
                    latitudes: 3,
                    longitudes: 12
                }, {
                    latitudes: 3,
                    longitudes: 16
                }, {
                    latitudes: 5,
                    longitudes: 16
                }, {
                    latitudes: 7,
                    longitudes: 16
                }, {
                    latitudes: 9,
                    longitudes: 16
                }, {
                    latitudes: 11,
                    longitudes: 16
                }, {
                    latitudes: 13,
                    longitudes: 16
                }, {
                    latitudes: 14,
                    longitudes: 16
                }
            ]
        };

        this._16x16RetailSequence = {
            latitudes: ['I', 'F', 'C', 'L', 'H', 'E', 'G', 'D', 'J', 'K', 'B', 'M', 'N', 'O'],
            longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
            limits: [{
                    latitudes: 1,
                    longitudes: 16
                }, {
                    latitudes: 2,
                    longitudes: 16
                }, {
                    latitudes: 3,
                    longitudes: 16
                }, {
                    latitudes: 4,
                    longitudes: 16
                }, {
                    latitudes: 5,
                    longitudes: 16
                }, {
                    latitudes: 6,
                    longitudes: 16
                }, {
                    latitudes: 7,
                    longitudes: 16
                }, {
                    latitudes: 8,
                    longitudes: 16
                }, {
                    latitudes: 9,
                    longitudes: 16
                }, {
                    latitudes: 14,
                    longitudes: 16
                }
            ]
        };

        this._Xx16RetailSequence = {
            latitudes: ['I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'J', 'K', 'L', 'M', 'N', 'O'],
            longitudes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
            limits: [{
                    latitudes: 1,
                    longitudes: 16
                }, {
                    latitudes: 2,
                    longitudes: 16
                }, {
                    latitudes: 3,
                    longitudes: 16
                }, {
                    latitudes: 4,
                    longitudes: 16
                }, {
                    latitudes: 5,
                    longitudes: 16
                }, {
                    latitudes: 6,
                    longitudes: 16
                }, {
                    latitudes: 7,
                    longitudes: 16
                }, {
                    latitudes: 8,
                    longitudes: 16
                }, {
                    latitudes: 9,
                    longitudes: 16
                }, {
                    latitudes: 14,
                    longitudes: 16
                }
            ]
        };

        this._progressSubscribers = [];
        this._currentStage = 0;
        this._currentImage = 0;
        this._stageImage = 0;
        this._interactivityImages = 0;
        this._totalStages = 0;
        this._totalImages = 0;
        this._stageCounts = [];
        this._loadingStart = 0;
    };

    AtlasLoadingSequence.prototype.getSequentialLoadingSequence = function(latitudes, longitudes, maxSpanForAnimation) {
        if (!maxSpanForAnimation) {
            maxSpanForAnimation = longitudes;
        }

        var sequence = [];

        var currentStage = {
            name: 'stage-sequential',
            limits: {
                latitudes: latitudes.length,
                longitudes: longitudes.length
            },
            latitudes: latitudes.slice(0),
            longitudes: longitudes.slice(0),
            animationEnabled: true
        };

        sequence.push(currentStage);

        return sequence;
    };

    AtlasLoadingSequence.prototype.get16x16Sequence = function() {
        return this._16x16Sequence;
    };

    AtlasLoadingSequence.prototype.get16x16PrioritySequence = function(outOfBand, maxSpanForAnimation) {
        return this.getPrioritySequence(this._16x16PrioritySequence, outOfBand, maxSpanForAnimation);
    };

    AtlasLoadingSequence.prototype.getXx16RetailSequence = function(latitudeSubset, outOfBand, maxSpanForAnimation) {
        if (latitudeSubset && latitudeSubset.length) {
            this._Xx16RetailSequence.latitudes = latitudeSubset.slice(0);

            //lop off any stages that exceed the count of latitudes that we are loading and set the last limit to the # of latitudes we
            //want to load (this could cause a duplicate stage, however since everyhting will be in cache it should not cause an impact)
            var i = 0;
            while ((i < this._Xx16RetailSequence.limits.length) && (this._Xx16RetailSequence.limits[i].latitudes < latitudeSubset.length)) {
                ++i;
            }

            if (i < this._Xx16RetailSequence.limits.length) {
                this._Xx16RetailSequence.limits.splice(i + 1, this._Xx16RetailSequence.limits.length - (i + 1));
                this._Xx16RetailSequence.limits[i].latitudes = latitudeSubset.length;
            }

            if (outOfBand) {
                //now go through and remove any limits that are less than the out of band latitude count
                var j = (this._Xx16RetailSequence.limits.length - 1);
                while ((j >= 0) && (this._Xx16RetailSequence.limits[j].latitudes > outOfBand.latitudes.length)) {
                    j--;
                }
                if (j > 0) {
                    this._Xx16RetailSequence.limits.splice(0, j);
                }
            }

            return this.getPrioritySequence(this._Xx16RetailSequence, outOfBand, maxSpanForAnimation);
        } else {
            return this.get16x16RetailSequence(outOfBand, maxSpanForAnimation);
        }
    };

    AtlasLoadingSequence.prototype.get16x16RetailSequence = function(outOfBand, maxSpanForAnimation) {
        return this.getPrioritySequence(this._16x16RetailSequence, outOfBand, maxSpanForAnimation);
    };

    AtlasLoadingSequence.prototype.getXx16PrioritySequence = function(latitudeSubset, outOfBand, maxSpanForAnimation) {
        //for right now return Xx16RetailSequence, this may need to be updated once loading sequences are revisited
        return this.getXx16RetailSequence(latitudeSubset, outOfBand, maxSpanForAnimation);
    };

    AtlasLoadingSequence.prototype.getPrioritySequence = function(prioritySequence, outOfBand, maxSpanForAnimation) {
        if (!maxSpanForAnimation) {
            maxSpanForAnimation = prioritySequence.longitudes.length;
        }

        //the full loading sequence
        var sequence = [];

        //the current limitations for the stage that we are on
        var currentStageIndex = 0;

        var currentStage = {
            name: 'stage-' + currentStageIndex,
            limits: prioritySequence.limits[0],
            latitudes: (outOfBand && outOfBand.latitudes && outOfBand.latitudes.length) ? outOfBand.latitudes.slice(0) : [],
            longitudes: (outOfBand && outOfBand.longitudes && outOfBand.longitudes.length) ? outOfBand.longitudes.slice(0) : [],
            animationEnabled: true
        };

        //continue until we have all of the stages handled
        while (currentStageIndex < prioritySequence.limits.length) {
            //deal with latitudes first - these are just off priority, not bisecting
            var currentPriorityLatitudeIndex = 0;
            while ((currentPriorityLatitudeIndex < prioritySequence.latitudes.length) && (currentStage.latitudes.length < prioritySequence.limits[currentStageIndex].latitudes)) {
                if (currentStage.latitudes.indexOf(prioritySequence.latitudes[currentPriorityLatitudeIndex]) < 0) {
                    currentStage.latitudes.push(prioritySequence.latitudes[currentPriorityLatitudeIndex]);
                }
                currentPriorityLatitudeIndex++;
            }

            //deal with longitudes next - these are bisecting first, then priority
            if ((Constants.USE_BISECT_LONGITUDES) && (currentStage.longitudes.length < prioritySequence.limits[currentStageIndex].longitudes)) {
                //if we still have room for more longitudes, then add them in priority order (longest bisect, followed by order in loading sequence)
                var previousLongitudes = null;
                //if this is not the first stage, then use the previous stage longitudes (since those should contain the same out of band longitudes
                //plus the currently loaded latitude list), however if this is the first stage, then we just need to order the current out of band
                //longitudes and use that as our base
                if (sequence.length > 1) {
                    previousLongitudes = sequence[sequence.length - 1].longitudes;
                }
                else {
                    previousLongitudes = currentStage.longitudes.sort();
                }

                //calculate the spans based on latitudes that are currently loaded
                var spans = [];
                for (var i = 1; i <= previousLongitudes.length; ++i) {
                    var lastLongitude = Constants.longitudeMarkers.indexOf(previousLongitudes[i - 1]);
                    var thisLongitude = Constants.longitudeMarkers.indexOf(previousLongitudes[i % previousLongitudes.length]);
                    //if (lastLongitude>thisLongitude)
                    //    lastLongitude=(prioritySequence.longitudes.length-lastLongitude)+1;
                    var span = Math.abs(thisLongitude - lastLongitude + (lastLongitude > thisLongitude ? prioritySequence.longitudes.length : 0));
                    spans.push({
                        span: span,
                        leftLongitudeIndex: lastLongitude,
                        leftLongitude: previousLongitudes[i - 1],
                        rightLongitudeIndex: thisLongitude,
                        rightLongitude: previousLongitudes[i % previousLongitudes.length]
                    });
                }

                //if we only have one span (a single longitude is loaded), then just load based on priority, however,
                //if we have more than one span, then we should fill based on bisecting longest span
                if (spans.length > 1) {
                    var spansAvailable = true;
                    while ((currentStage.longitudes.length < prioritySequence.limits[currentStageIndex].longitudes) && (spansAvailable)) {
                        //pick the biggest span
                        var maxSpan = -1;
                        var maxSpanIndex = -1;
                        for (var s = 0; s < spans.length; ++s) {
                            if ((spans[s].span > maxSpan) && (spans[s].span > 2)) {
                                maxSpan = spans[s].span;
                                maxSpanIndex = s;
                            }
                        }
                        if ((maxSpan > -1) && (maxSpanIndex > -1)) {
                            var halfSpan = Math.floor(maxSpan / 2);

                            //calculate the next
                            var halfSpanLongitudeIndex = (spans[maxSpanIndex].leftLongitudeIndex + halfSpan) % prioritySequence.longitudes.length;
                            var halfSpanLongitude = Constants.longitudeMarkers[halfSpanLongitudeIndex];

                            var leftSpan = {
                                span: halfSpan,
                                leftLongitudeIndex: spans[maxSpanIndex].leftLongitudeIndex,
                                leftLongitude: spans[maxSpanIndex].leftLongitude,
                                rightLongitudeIndex: halfSpanLongitudeIndex,
                                rightLongitude: halfSpanLongitude
                            };

                            var rightSpan = {
                                span: spans[maxSpanIndex].span - halfSpan,
                                leftLongitudeIndex: halfSpanLongitudeIndex,
                                leftLongitude: halfSpanLongitude,
                                rightLongitudeIndex: spans[maxSpanIndex].rightLongitudeIndex,
                                rightLongitude: spans[maxSpanIndex].rightLongitude
                            };

                            var leftSpans = spans.slice(0, maxSpanIndex);
                            leftSpans.push(leftSpan);
                            leftSpans.push(rightSpan);
                            spans = leftSpans.concat(spans.slice(maxSpanIndex + 1));

                            currentStage.longitudes.push(halfSpanLongitude);
                        } else {
                            //nothing more to split
                            spansAvailable = false;
                        }
                    }
                }
            }

            //at this point fill up whatever else is needed based on priority arrays
            var currentPriorityLongitudeIndex = 0;
            while (currentStage.longitudes.length < prioritySequence.limits[currentStageIndex].longitudes) {
                if (currentStage.longitudes.indexOf(prioritySequence.longitudes[currentPriorityLongitudeIndex]) < 0) {
                    currentStage.longitudes.push(prioritySequence.longitudes[currentPriorityLongitudeIndex]);
                }
                currentPriorityLongitudeIndex++;
            }

            currentStage.longitudes.sort();
            currentStage.latitudes.sort();

            //if there is a max span then calculate
            if (maxSpanForAnimation < prioritySequence.longitudes.length) {
                //calculate the spans based on latitudes that are currently loaded
                for (var i = 1; i <= currentStage.longitudes.length; ++i) {
                    var lastLongitude = Constants.longitudeMarkers.indexOf(currentStage.longitudes[i - 1]);
                    var thisLongitude = Constants.longitudeMarkers.indexOf(currentStage.longitudes[i % currentStage.longitudes.length]);
                    //if (lastLongitude>thisLongitude)
                    //    lastLongitude=(prioritySequence.longitudes.length-lastLongitude)+1;
                    var span = Math.abs(thisLongitude - lastLongitude + (lastLongitude > thisLongitude ? prioritySequence.longitudes.length : 0));
                    if (span > maxSpanForAnimation) {
                        currentStage.animationEnabled = false;
                        break;
                    }
                }
            }

            ++currentStageIndex;

            sequence.push(currentStage);
            currentStage = {
                name: 'stage-' + currentStageIndex,
                limits: prioritySequence.limits[currentStageIndex],
                latitudes: sequence[sequence.length - 1].latitudes.slice(0),
                longitudes: sequence[sequence.length - 1].longitudes.slice(0),
                animationEnabled: true
            };
        }

        //if we ended up including everything in the out of band stage, and there are not sequences, then add what we have and move on
        if (sequence.length === 0) {
            sequence.push(currentStage);
        }

        return sequence;
    };

    AtlasLoadingSequence.prototype.addProgressSubscriber = function(callback, data, loader, sequence) {
        this._stageCounts = [];
        this._currentStage = 0;
        this._currentImage = 0;
        this._stageImage = 0;
        this._interactivityImages = 0;
        this._totalStages = 0;
        this._totalImages = 0;
        this._loadingStart = 0;


        //update the totals based on the sequence
        this._totalStages = sequence.length;
        this._interactivityImages = 0;
        this._totalImages += (sequence[sequence.length - 1].latitudes.length * sequence[sequence.length - 1].longitudes.length);

        for (var s = 0; s < this._totalStages; ++s) {
            //calculate the images needed for interactivity
            if ((sequence[s].animationEnabled) && (this._interactivityImages === 0)) {
                this._interactivityImages = sequence[s].latitudes.length * sequence[s].longitudes.length;
            }

            //calculate the count of images per stage
            if (s === 0) {
                this._stageCounts.push(sequence[s].latitudes.length * sequence[s].longitudes.length);
            }
            else {
                this._stageCounts.push(sequence[s].latitudes.length * sequence[s].longitudes.length - sequence[s - 1].latitudes.length * sequence[s - 1].longitudes.length);
            }
        }

        var subscriber = {
            callback: callback,
            data: data
        };
        this._progressSubscribers.push(subscriber);

        if (this._progressSubscribers.length === 1) {
            loader.addImageSubscriber(function(image, object) {
                if (object._currentImage === 0) {
                    object._loadingStart = new Date();
                }

                object._currentImage++;
                object._stageImage++;
                if (object._stageImage >= object._stageCounts[object._currentStage]) {
                    object._currentStage++;
                    object._stageImage = 0;
                }

                var current = new Date();

                var estimatedTimeRemaining = (object._currentImage <= 10 ? 30000 : 1000 + ((current.getTime() - object._loadingStart.getTime()) / object._currentImage) * (object._totalImages - object._currentImage));

                var progress = {
                    stageTotal: object._stageCounts[object._currentStage],
                    stageCount: object._stageImage,
                    stagePercentage: object._stageImage / object._stageCounts[object._currentStage],
                    interactivityTotal: object._interactivityImages,
                    interactivityCount: object._currentImage,
                    interactivityPercentage: object._currentImage / object._interactivityImages,
                    imageTotal: object._totalImages,
                    imageCount: object._currentImage,
                    imagePercentage: object._currentImage / object._totalImages,
                    elapsedTime: current.getTime() - object._loadingStart.getTime(),
                    estimatedTimeRemaining: estimatedTimeRemaining,
                    lastImage: image
                };

                for (var p = 0; p < object._progressSubscribers.length; ++p) {
                    object._progressSubscribers[p].callback(progress, object._progressSubscribers[p].data);
                }
            }, this);
        }
    };

    AtlasLoadingSequence.prototype.clearProgressSubscribers = function() {
        this._progressSubscribers = [];
    };

    return AtlasLoadingSequence;
});
